module.exports = __webpack_public_path__ + "img/full_logo.7e0fc138.png";